import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { storeWriteSettingsAdapts } from './store-write-settings.adapter';
import { AmazonS3CompatibleWriteSettings } from 'app/model/pipeline/copysink/store-write-settings/amazon-s3-compatible-store-write-settings';
import { AmazonS3WriteSettingsAdapter } from './amazon-s3-store-write-settings.adapter';

@AdapterRegistry.adapter({
    model:  Metamodel.modelFor(AmazonS3CompatibleWriteSettings),
    asynchronous: true,
    adapts: {
        ...storeWriteSettingsAdapts
    }
})

export class AmazonS3CompatibleWriteSettingsAdapter extends AmazonS3WriteSettingsAdapter {}
